import { DateInput, Input, Label, Textarea } from "../../../../../components"
import { Controller, useFormContext } from "react-hook-form"
import type { DataList } from "../types"
import moment from "moment"

export const FormSection = ({ disabled }: { disabled?: boolean }) => {
  const { control } = useFormContext<DataList>()

  return (
    <table className="table">
      <tbody>
          <Controller 
              control={control}
              name="transaction_date"
              render={({ field, fieldState }) => 
                  <tr>
                      <td><Label text="DATE" error={Boolean(fieldState.error)} /></td>
                      <td>
                          <DateInput
                            ref={field.ref}
                            selected={field.value ? moment(new Date(field.value)).toDate() : undefined}
                            onChange={value => field.onChange(moment(value).format("YYYY-MM-DD"))}
                            error={fieldState.error?.message}
                            disabled
                          />
                      </td>
                  </tr>
              }
          />

          <Controller
              control={control}
              name="file_name"
              render={({ field, fieldState }) => 
                  <tr>
                      <td><Label text="FILE NAME" error={Boolean(fieldState.error)} /></td>
                      <td>
                          <Input 
                            {...field} 
                            placeholder="Input file name" 
                            value={field.value ?? ""} 
                            error={fieldState.error?.message}
                            disabled={disabled}
                          />
                      </td>
                  </tr>
              }
          />

          <Controller
            control={control}
            name="file_description"
            render={({ field, fieldState }) => 
                <tr>
                    <td><Label text="DESCRIPTION" error={Boolean(fieldState.error)} /></td>
                    <td>
                        <Textarea
                        {...field} 
                        placeholder="Input Description" 
                        value={field.value ?? ""}
                        error={fieldState.error?.message}
                        disabled={disabled}
                        />
                    </td>
                </tr>
            }
          />
      </tbody>
    </table>
  )
}